import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { GitBranch, Play } from 'lucide-react';

interface ScenariosScreenThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function ScenariosScreenThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: ScenariosScreenThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <CardTitle className="text-sm font-medium">Scenario Planning</CardTitle>
            <GitBranch className="h-4 w-4 text-muted-foreground" />
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <div className="flex items-center justify-between p-3 rounded bg-green-50 border border-green-200">
              <div className="flex items-center gap-2">
                <Play className="h-4 w-4 text-green-600" />
                <div>
                  <div className="text-sm font-medium">Current Plan</div>
                  <div className="text-xs text-muted-foreground">Base scenario</div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-sm font-semibold">£287K</div>
                <Badge className="bg-green-600 text-[10px]">Active</Badge>
              </div>
            </div>
            <div className="flex items-center justify-between p-3 rounded bg-muted/50">
              <div className="flex items-center gap-2">
                <GitBranch className="h-4 w-4 text-blue-500" />
                <div>
                  <div className="text-sm font-medium">Aggressive Growth</div>
                  <div className="text-xs text-muted-foreground">High investment</div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-sm font-semibold">£245K</div>
                <Badge variant="outline" className="text-[10px]">Draft</Badge>
              </div>
            </div>
            <div className="flex items-center justify-between p-3 rounded bg-muted/50">
              <div className="flex items-center gap-2">
                <GitBranch className="h-4 w-4 text-purple-500" />
                <div>
                  <div className="text-sm font-medium">Conservative</div>
                  <div className="text-xs text-muted-foreground">Low risk</div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-sm font-semibold">£312K</div>
                <Badge variant="outline" className="text-[10px]">Draft</Badge>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
